import React from 'react';

import { useViewType, ViewType } from '@eika/hooks';
import { InfoLabel } from '@eika/label';

import useTranslation from '../../hooks/useTranslation';

import './AvtalegiroDetailsHeader.scss';

interface Props {
    lastPaymentDate?: string;
}

const AvtalegiroDetailsHeader = ({ lastPaymentDate }: Props) => {
    const translated = useTranslation();
    const viewType = useViewType();
    const isMobile = viewType === ViewType.mobile;

    const labelText = lastPaymentDate && `${translated.avtaleGiroAgreement.lastPayment} ${lastPaymentDate}`;

    return (
        <div className="avtalegiro-details-header__container">
            <h2 className="avtalegiro-details-header__title">{translated.avtaleGiroAgreement.createTitle}</h2>
            {!!lastPaymentDate && (
                <div>
                    <InfoLabel text={labelText} size={isMobile ? 'small' : 'standard'} />
                </div>
            )}
        </div>
    );
};

export default AvtalegiroDetailsHeader;
